import axios from "axios";
import { c_API_IP } from "./CommonURL";

export default axios.create({
  baseURL: c_API_IP,
  headers: {
    "Content-Type": "application/json",
  },
});
